import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'

import './style.css'
import { i18n } from './i18n'
import router from './router'
import '@/api/client'

/**
 * Stores
 */
const pinia = createPinia()

/**
 * App
 */
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n as any)
app.mount('#app')
